export var DoNotShowAgainKeys = /*#__PURE__*/ function(DoNotShowAgainKeys) {
    DoNotShowAgainKeys["NC_DELETE_BUCKET"] = "nc.bucket";
    DoNotShowAgainKeys["NC_MARK_TYPE_AS_READ"] = "nc.mark_type_as_read";
    DoNotShowAgainKeys["NC_MOVE_SELECTION"] = "nc.move_selection";
    DoNotShowAgainKeys["NC_MARK_SELECTION_AS_UNREAD"] = "nc.mark_selection_as_unread";
    DoNotShowAgainKeys["NC_MARK_ALL_READ"] = "nc.mark_all_read";
    return DoNotShowAgainKeys;
}({});
export var CloseOnConfirmOption = /*#__PURE__*/ function(CloseOnConfirmOption) {
    CloseOnConfirmOption["CloseOnCancelOnly"] = "cancel-only";
    CloseOnConfirmOption["DontClose"] = "dont-close";
    return CloseOnConfirmOption;
}({});

//# sourceMappingURL=types.js.map